exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-carousel-thumb{height:100%;min-width:25%;border:2px double #fff;*flex-shrink:1;*display:inline-block;*white-space:normal;*border-radius:5px}.v-carousel-thumb.active{border:2px double red}.v-carousel-thumb>.item__image{text-align:center;height:100%;width:100%}.v-carousel-thumb>.item__image img{height:100%;*width:100%}", ""]);

// exports
